import React, { useState, useContext, useEffect } from 'react';
import { DBContext } from '../../../controller/contexts/dbContext';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Image from 'material-ui-image';
var moment = require('moment');

const HomeworkEvalutationDialogue = ({ close, homeworkToView, homeworkSubmissonData, open, saveEvaluation }) => {
  const classes = useStyles();
  const [score, setScore] = useState(null);
  const [remarks, setRemarks] = useState('');

  useEffect(() => {
    if (homeworkSubmissonData.score) {
      setScore(parseInt(homeworkSubmissonData.score))
    }
    if (homeworkSubmissonData.remarks) {
      setRemarks(homeworkSubmissonData.remarks)
    }
  }, [homeworkSubmissonData.id])

  const handleEvaluation = () => {
    if (score == null) {
      return alert('Please provide score for the homework')
    } else {
      // save the evaluation data 
      close()
      return saveEvaluation(homeworkToView.id, homeworkSubmissonData.id, {
        score,
        remarks,
        isEvaluationDone: true,
      })
    }
  }

  const updateRemarks = (e) => {
    // console.log('remarks', e.target.value);
    setRemarks(e.target.value);
  }
  const handleRadioChange = (e) => {
    //console.log('score', typeof (e.target.value));
    setScore(parseInt(e.target.value))
  }
  return (
    <>
      <Dialog onClose={close} aria-labelledby="customized-dialog-evolve-homework" open={open} className={classes.padding}>
        <DialogTitle id="customized-dialog-evolve-homework" onClose={close}>
          {
            <>
              <Typography variant="h5">Evaluate Homework</Typography>
              <Typography variant="body2" color="textSecondary">
                Please check the homework and give the score
            </Typography>
            </>
          }
        </DialogTitle>
        <DialogContent dividers>

          <div className={classes.padding}>
            {/* For showing*/}

            <div>
              {homeworkSubmissonData.imageUrls ?
                homeworkSubmissonData.imageUrls.map((eachImage) => {
                  return (
                    <div className={classes.image}>
                      <Image src={eachImage} />
                    </div>
                  )
                })
                : <div>No images Uploaded</div>
              }
            </div>

            <Grid item xs={12} sm={10} className={classes.margin}>
              {/* For selecting Feedback*/}
              <Grid item xs={12} sm={10} >

                <FormControl component="fieldset">
                  <FormLabel component="legend">Feedback</FormLabel>
                  <RadioGroup
                    row aria-label="Feedback"
                    name="feedback"
                    onChange={handleRadioChange}
                    value={score}
                  >
                    <FormControlLabel
                      value={3}
                      control={<Radio color="primary" />}
                      label="Excellent"
                    />
                    <FormControlLabel
                      value={2}
                      control={<Radio color="primary" />}
                      label="Good"
                    />
                    <FormControlLabel
                      value={1}
                      control={<Radio color="primary" />}
                      label="Need to improve"
                    />
                    {/* <FormControlLabel
                      value={0}
                      control={<Radio color="primary" />}
                      label="Bad" /> */}
                  </RadioGroup>
                </FormControl>

              </Grid>
              {/* For Entering  Remarks*/}
              <Grid item xs={12} sm={10} className={classes.padding}>
                <TextField
                  id="outlined-required-homework-Remarks"
                  label="Remarks"
                  variant="outlined"
                  value={remarks}
                  onChange={updateRemarks}
                  fullWidth
                  multiline
                  rows={4}
                />
              </Grid>

            </Grid>
          </div>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" disabled={homeworkSubmissonData.isEvaluationDone} onClick={handleEvaluation} color="primary" className={classes.margin}>
            {homeworkSubmissonData.isEvaluationDone ? 'Already Submitted' : 'Submit'}
          </Button>
        </DialogActions>
      </Dialog>

    </>);
}

const styles = (theme) => ({
  root: {
    with: '100%',
    margin: 0,
    padding: theme.spacing(1),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogContent = withStyles((theme) => ({
  root: {
    with: '100%',
    padding: theme.spacing(1),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const useStyles = makeStyles((theme) => ({
  root: {
    with: '100%',
    flexGrow: 1,
    marginTop: '8%',
    padding: theme.spacing(1),
    marginBottom: '2%',

  },
  padding: {
    padding: theme.spacing(1),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    maxWidth: 300,
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: 2,
  },
  noLabel: {
    marginTop: theme.spacing(3),
  },
  input: {
    display: 'none',
  },
  image: {
    padding: theme.spacing(1),
    minWidth: 550,
    minHeight: 600,
  },
  margin: {
    margin: 8,
  }
}));

export default HomeworkEvalutationDialogue;